import React from "react";
import { Dialog as KendoDialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import Error from './Views/Error';
import Standard from './Views/Standard';
import Loading from './Views/Loading'

const Dialog = (props) => {
  return (
    props.type === 'ERR' ?
      <Error {...props} /> :
      props.type === 'LOAD' ?
        <Loading {...props}/> :
        <Standard {...props}/>
  )
}

const styles = {
  content: {
    minWidth: '275px',
  },
  text: {
    margin: '10px 10px 20px 10px',
    textAlign: 'center',
    maxWidth: '350px',
  },
  modalBtn: {
    padding: '10px 15px'
  },
}

export default Dialog;